import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import MainHeader from "../components/MainHeader/MainHeader";
import "./container.css";
import { useSelector } from "react-redux";
import { darkTheme, lightTheme } from "../theme/Theme";
import LoginFooter from "../components/LoginComponent/LoginFooter";
import useResize from "../hooks/useResize";

const Container = () => {
  const isDarkTheme = useSelector((state) => state.theme);
  const { navigations } = useSelector((state) => state.nav);
  const { isZoomed } = useResize();

  const isNavlarge = navigations?.length > 13 ? true : false;
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <MainHeader data-testid="main-header" />

      <main
        className={`responsive-main  ${isNavlarge ? "nav-large" : ""}`}
        data-testid="main-container"
        style={{
          marginTop: isZoomed ? "6rem" : "",
          background: isDarkTheme
            ? darkTheme.backgroundColorLayer1
            : lightTheme.backgroundColorLayer1,
          flex: 1, // ADD THIS to allow the outlet to expand and work with StyledParent
          display: "flex", // Required for children using flex-grow
          flexDirection: "column",
        }}
      >
        <Outlet data-testid="outlet-container" />
      </main>
      <LoginFooter data-testid="login-footer" />
    </div>
  );
};

export default Container;
